import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Nav from '../components/common/Nav';
import Footer from '../components/common/Footer';
import SEO from '../components/common/SEO';
import { getPostBySlug } from '../utils/blogLoader';

export default function BlogPost() {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  if (!post) {
    return (
      <>
        <Nav />
        <div className="container" style={{ paddingTop: '120px', textAlign: 'center' }}>
          <h1>Post not found</h1>
          <p>The blog post you're looking for doesn't exist.</p>
          <Link to="/blog">← Back to blog</Link>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <SEO 
        title={post.title}
        description={post.excerpt}
        image={post.featured_image}
        url={`/blog/${slug}`}
        type="article"
        publishedTime={post.date}
      />
      <Nav />
      
      <header style={{ padding: 0, margin: 0, minHeight: 'auto' }}>
        <div className="container" style={{ paddingTop: '96px', paddingBottom: 0 }}>
          <div className="section-header">
            <div className="post-date" style={{ margin: '3px 0', padding: '3px 2px' }}>
              [{post.date}]
            </div>
            <h1 style={{ fontSize: '28px', marginTop: 0, marginBottom: '15px', padding: '3px 2px', lineHeight: 1.3 }}>
              {post.title}
            </h1>
            
            {post.featured_image && (
              <figure className="notion-image-full">
                <img 
                  src={post.featured_image} 
                  alt={post.title}
                  loading="lazy"
                  style={{ maxWidth: '100%', height: 'auto', borderRadius: '3px' }}
                />
              </figure>
            )}
            
            <hr style={{ border: 'none', borderTop: '1px solid var(--border-color)', margin: '22px 0' }} />
          </div>
        </div>
      </header>

      <main className="about" style={{ borderTop: 'none', padding: 0 }}>
        <div className="container" style={{ paddingTop: 0 }}>
          <article className="content">
            <ReactMarkdown 
              remarkPlugins={[remarkGfm]}
              components={{
                // Custom image rendering
                img: ({ node, ...props }) => (
                  <img 
                    {...props} 
                    loading="lazy"
                    style={{ maxWidth: '100%', height: 'auto', borderRadius: '3px', margin: '20px 0' }}
                  />
                ),
                // Custom link rendering (open external links in new tab)
                a: ({ node, href, children, ...props }) => {
                  const isExternal = href && (href.startsWith('http') || href.startsWith('//'));
                  return (
                    <a 
                      href={href}
                      {...props}
                      {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                    >
                      {children}
                    </a>
                  );
                },
                // Custom blockquote styling
                blockquote: ({ node, children, ...props }) => (
                  <blockquote {...props} style={{ 
                    borderLeft: '3px solid var(--accent-color)',
                    paddingLeft: '16px',
                    margin: '20px 0',
                    fontStyle: 'italic',
                    color: 'var(--accent-color)'
                  }}>
                    {children}
                  </blockquote>
                )
              }}
            >
              {post.content}
            </ReactMarkdown>

            <div style={{ marginTop: '40px', textAlign: 'center', padding: '20px', borderTop: '1px solid var(--border-color)' }}>
              <Link 
                to="/blog" 
                style={{ 
                  display: 'inline-block', 
                  marginTop: '15px', 
                  padding: '10px 20px', 
                  border: '1px solid var(--border-color)', 
                  textDecoration: 'none', 
                  color: 'var(--link-color)', 
                  transition: 'all 0.2s ease' 
                }}
              >
                ← View all blog articles
              </Link>
            </div>
          </article>
        </div>
      </main>

      <Footer />
    </>
  );
}
